import React, { FunctionComponent } from 'react';
import { DealerLaunchStepProps } from '../types';
import styles from '../styles.module.scss';
import { Radio } from '../../Input/Radio/Radio';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { Dealer } from '../../../types/dealerTypes';
import { addDeskingDefaults } from '../defaults';

export const DealerLaunchOnePerLease: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({
    defaultValues: addDeskingDefaults(dealer),
  });
  return (
    <DealerLaunchFormCardLayout
      className={styles.widgetsStep}
      form={form}
      title="Tell Us About How Your Payments Are Configured"
      subTitle=""
      cardTitle="Would you like to display a one pay lease option?"
      prevStep={prevStep}
      onFormSubmit={nextStep}
    >
      <Radio
        className="flex-column"
        name="desking.enableOnePayLease"
        options={[
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ]}
        form={form}
      />
    </DealerLaunchFormCardLayout>
  );
};
